import { createSlice } from '@reduxjs/toolkit'

export const utmSlice = createSlice({
  name: 'utm',
  initialState: {},
  reducers: {
    setUtm: (state, action) => action.payload,
  },
})

export const selectUtm = (state) => state.utm

export const { setUtm } = utmSlice.actions

export default utmSlice.reducer
